export default "__VITE_ASSET__C8bMkvj5__"